import { environment } from '../environments/environment';

/** Container entrypoint overwrites this file. Empty fields keep the build-time environment. */
export async function applyRuntimeConfig(): Promise<void> {
  try {
    const response = await fetch('/assets/runtime-config.json', { cache: 'no-store' });
    if (!response.ok) return;
    const data = (await response.json()) as {
      apiUrl?: unknown;
      OAuth2ClientId?: unknown;
      sharePublicBaseUrl?: unknown;
    };
    if (typeof data.apiUrl === 'string' && data.apiUrl.trim()) {
      environment.apiUrl = data.apiUrl.trim();
    }
    if (typeof data.OAuth2ClientId === 'string' && data.OAuth2ClientId.trim()) {
      environment.OAuth2ClientId = data.OAuth2ClientId.trim();
    }
    if (typeof data.sharePublicBaseUrl === 'string' && data.sharePublicBaseUrl.trim()) {
      environment.sharePublicBaseUrl = data.sharePublicBaseUrl.trim().replace(/\/+$/, '');
    }
  } catch {
    // A static build without the file keeps environment.ts / environment.prod.ts.
  }
}
